import exp from 'constants';
import { OrderType } from '../../../../interfaces/delivery-company/orders';
import CustomDialog from '../../custom-dialog/custom-dialog';
import { isMobile, isTablet } from 'react-device-detect';
import { IconButton, DialogContent } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import CodUpdateForm from '../cod-update-form/cod-update-form';
import { Money } from '../../../../utils/money';

interface CodUpdateDialogProps {
  order: OrderType;
  open: boolean;
  onSuccess: (m: Money[]) => void;
  onClose: () => void;
}
function CodUpdateDialog({ order, open, onClose, onSuccess }: CodUpdateDialogProps) {
  // This component will handle the dialog for updating COD
  // It will use the CodUpdateForm component to render the form
  return (
    <CustomDialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={() => onClose()}
      fullScreen={(isMobile && !isTablet)}
    >
      <div
        style={{
          textAlign: 'right',
          width: '100%',
        }}
      >
        <IconButton onClick={() => onClose()}>
          <ClearIcon color="primary" fontSize="large" />
        </IconButton>
      </div>

      <DialogContent>
        <CodUpdateForm
          order={order}
          onSuccess={onSuccess}
        />
      </DialogContent>
    </CustomDialog>
  );
}
export default CodUpdateDialog;
